import React from 'react';
import PackageSelectModal from '../modals/PackageSelectModal';

const BriefView = ({ state }) => {
  const {
    selectedTrend,
    briefData,
    savedResearch,
    showPackageModal,
    setShowPackageModal,
    sendToCSA,
    generateAudienceBrief,
    resetWorkflow,
  } = state;

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 24, fontWeight: '600', color: '#f3f4f6' }}>Content Brief Generated</h2>
          <p style={{ margin: '8px 0 0', color: '#9ca3af', fontSize: 14 }}>
            Choose routing: Direct to CSA or add to Package
          </p>
        </div>
        <button
          onClick={resetWorkflow}
          style={{
            backgroundColor: 'transparent',
            color: '#9ca3af',
            border: '1px solid #374151',
            padding: '10px 20px',
            borderRadius: 8,
            fontWeight: '500',
            cursor: 'pointer',
            fontSize: 13
          }}
        >
          {'\u2190'} Back to Dashboard
        </button>
      </div>

      <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 32, border: '1px solid #2d2d44' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24, paddingBottom: 24, borderBottom: '1px solid #2d2d44' }}>
          <div>
            <h3 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: '600', color: '#f3f4f6' }}>{briefData.title}</h3>
            <div style={{ display: 'flex', gap: 16, fontSize: 13, color: '#9ca3af', marginBottom: 12 }}>
              <span>Priority: <span style={{ color: '#ef4444', fontWeight: '500' }}>{briefData.priority}</span></span>
              <span>Target: {briefData.targetPublish}</span>
            </div>
            {/* Multi-category display */}
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <span style={{ fontSize: 11, color: '#6b7280', textTransform: 'uppercase' }}>Categories:</span>
              {(selectedTrend.categories || [selectedTrend.macro]).map((cat, idx) => (
                <span key={idx} style={{
                  padding: '4px 10px',
                  backgroundColor: '#3b82f620',
                  border: '1px solid #3b82f6',
                  borderRadius: 4,
                  fontSize: 11,
                  color: '#93c5fd'
                }}>
                  {cat}
                </span>
              ))}
            </div>
          </div>
          <div style={{ padding: '8px 16px', backgroundColor: '#065f46', borderRadius: 6, color: 'white', fontWeight: '600', fontSize: 12 }}>
            APPROVED
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 32 }}>
          <div>
            <h4 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Content Plan</h4>
            <div style={{ display: 'grid', gap: 12 }}>
              {briefData.contentPlan.map((item, idx) => (
                <div key={idx} style={{ padding: 16, backgroundColor: '#252540', borderRadius: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <span style={{
                      fontSize: 11,
                      fontWeight: '600',
                      padding: '2px 8px',
                      borderRadius: 4,
                      backgroundColor: item.type === 'Pillar' ? '#6366f1' : item.type === 'Supporting' ? '#374151' : '#065f46',
                      color: 'white'
                    }}>
                      {item.type}
                    </span>
                    <span style={{ fontSize: 12, color: '#6b7280' }}>{item.wordCount} words</span>
                  </div>
                  <div style={{ fontSize: 14, fontWeight: '500', color: '#f3f4f6', marginBottom: 4 }}>{item.title}</div>
                  <div style={{ fontSize: 12, color: '#9ca3af' }}>{item.format}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div style={{ marginBottom: 24 }}>
              <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>SEO Targets</h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {briefData.seoTargets.map((keyword, idx) => (
                  <span key={idx} style={{ padding: '4px 10px', backgroundColor: '#252540', borderRadius: 4, fontSize: 12, color: '#d1d5db' }}>
                    {keyword}
                  </span>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: 24 }}>
              <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Commerce Integration</h4>
              <p style={{ margin: 0, fontSize: 13, color: '#d1d5db', lineHeight: 1.6 }}>{briefData.commerceIntegration}</p>
            </div>

            <div>
              <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Audience Targeting</h4>
              <p style={{ margin: 0, fontSize: 13, color: '#d1d5db', lineHeight: 1.6 }}>{briefData.audienceTargeting}</p>
            </div>

            {/* Research Attached Indicator */}
            {savedResearch.length > 0 && (
              <div style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid #2d2d44' }}>
                <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: '600', color: '#f59e0b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Research Attached ({savedResearch.length})
                </h4>
                <div style={{ display: 'grid', gap: 8 }}>
                  {savedResearch.map(research => (
                    <div key={research.id} style={{
                      padding: 12,
                      backgroundColor: '#252540',
                      borderRadius: 6,
                      borderLeft: '3px solid #f59e0b'
                    }}>
                      <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>
                        {research.agents.join(', ')} {'\u2022'} {research.timestamp}
                      </div>
                      <div style={{ fontSize: 13, color: '#d1d5db' }}>
                        {research.query}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Routing Options */}
      <div style={{ marginTop: 24 }}>
        <h4 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Route This Brief
        </h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {/* Option 1: Direct to CSA */}
          <div style={{
            backgroundColor: '#1e1e32',
            borderRadius: 12,
            padding: 24,
            border: '1px solid #2d2d44',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onClick={sendToCSA}
          onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#10b981';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d2d44';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                backgroundColor: '#10b98120',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20
              }}>
                {'\u26A1'}
              </div>
              <div>
                <h5 style={{ margin: 0, fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Direct to CSA</h5>
                <p style={{ margin: 0, fontSize: 12, color: '#6b7280' }}>Immediate processing</p>
              </div>
            </div>
            <p style={{ margin: 0, fontSize: 13, color: '#9ca3af', lineHeight: 1.6 }}>
              Send brief through SEO API scoring and directly to Content Scaling Agent for draft generation. Best for standalone opportunities or time-sensitive content.
            </p>
            <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: '#10b981', fontWeight: '500' }}>Send Now {'\u2192'}</span>
            </div>
          </div>

          {/* Option 2: Add to Package */}
          <div style={{
            backgroundColor: '#1e1e32',
            borderRadius: 12,
            padding: 24,
            border: '1px solid #2d2d44',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onClick={() => setShowPackageModal(true)}
          onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#8b5cf6';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d2d44';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                backgroundColor: '#8b5cf620',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20
              }}>
                {'\uD83D\uDCE6'}
              </div>
              <div>
                <h5 style={{ margin: 0, fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Add to Package</h5>
                <p style={{ margin: 0, fontSize: 12, color: '#6b7280' }}>Bundle for delivery</p>
              </div>
            </div>
            <p style={{ margin: 0, fontSize: 13, color: '#9ca3af', lineHeight: 1.6 }}>
              Add to a macro trend package for coordinated editorial delivery. Package multiple briefs for themed content pushes across verticals.
            </p>
            <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: '#8b5cf6', fontWeight: '500' }}>Select Package {'\u2192'}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Package Selection Modal */}
      {showPackageModal && (
        <PackageSelectModal state={state} />
      )}

      {/* Generate Audience Brief Button */}
      <div style={{ marginTop: 24, paddingTop: 24, borderTop: '1px solid #2d2d44' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h4 style={{ margin: '0 0 4px', fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>Audience Brief</h4>
            <p style={{ margin: 0, fontSize: 13, color: '#9ca3af' }}>Generate audience targeting and channel strategy for Growth & Engagement teams</p>
          </div>
          <button
            onClick={generateAudienceBrief}
            style={{
              backgroundColor: '#f59e0b',
              color: '#0f0f1a',
              border: 'none',
              padding: '12px 24px',
              borderRadius: 8,
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fbbf24'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f59e0b'}
          >
            <span>{'\uD83D\uDCCA'}</span>
            Generate Audience Brief
          </button>
        </div>
      </div>
    </div>
  );
};

export default BriefView;
